module.exports = __webpack_public_path__ + "static/media/test-product-by-brand-2.e5729ceb.png";